/************
 * Service Class
 * File Name ...: transactionhistory.service.ts
 * Generated By : ianday on 2/18/23
 * Date ........: 2/18/23
 /************/
import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {retry, catchError} from 'rxjs/operators';
import {TransactionHistory} from '../models/transactionhistory';
import {Settings} from './settings';
import {isNumber} from 'chart.js/helpers';
import {DwUtils} from '../components/utils/dw-utils';

@Injectable({
    providedIn: 'root'
})
export class TransactionHistoryService {

    public URLPath: string = Settings.getInstance().BASE_URL + 'general/transactionHistory/';
    public excludeArr: any
    constructor(private http: HttpClient) {
        this.excludeArr = [];

        this.excludeArr.push('dateCreated');
        this.excludeArr.push('dateModified');
    }

    public excludeProperty(prop): boolean {

        const idx = this.excludeArr.findIndex((element) => element === prop);

        if(idx > -1) {
            return true;
        }

        return false;
    }
    createTransactionHistory(tableVal: string, keyId: number,
                             txType: string = 'Create',
                             txAction: string = 'Adding New Record',
                             newVal: string = '',
                             columnOrElement: string = ''): void{
        const txHist: TransactionHistory = new TransactionHistory();
        txHist.setRecord(txType, tableVal, keyId, txAction, newVal, columnOrElement);
        this.postTxHistoryRecord(txHist).subscribe(
        		(data) => {
                    // nothing
                },
            	(error) => {
                    alert(error);
                }
    		);
    }

    updateTransactionHistory(stHist: object, stNew: object, tableVal: string, keyId: number, skipCols:any = []): void {

        /************
         * evaluate the structures together, we will assume that they are the same.
         * the st1 structure was the original, st2 structure is the new structure.
         ***********/

        for (const prop in stHist) {
            if (!stHist.hasOwnProperty(prop)) {
                continue;
            }

            if(this.excludeProperty(prop) === true) {
                continue;
            }

            if(skipCols.length > 0) {
                if(skipCols.includes(prop)) {
                    continue;
                }
            }
            try {
            	let oldVal = stHist[prop];
            	let newVal = stNew[prop];
            	if(!oldVal)
            		oldVal = '';
            	if(!newVal)
            		newVal = '';
                if (oldVal !== newVal) {

                    /*** solve for  "51.50" === 51.5  ***/
                    if (isNumber(stHist[prop]) === true) {
                        if (Number(stHist[prop]) === stNew[prop]) {
                            continue;
                        }
                    }

                    // something has changed
                    const txHist: TransactionHistory = new TransactionHistory();
                    txHist.setRecord('Edit', tableVal, keyId, '');
                    txHist.valueChange(stHist[prop], stNew[prop], prop);
                    this.postTxHistoryRecord(txHist).subscribe(
                        (data) => {
                            // nothing
                        },
                    (error) => {
                            alert(error);
                        }
                    );
                }
            }
            catch {}
        }
    }

    /** Clerical reclose updates dateCreated/dateCompleted server-side; those fields are excluded from updateTransactionHistory. */
    logServiceRequestDateChanges(
        serviceRequestId: number,
        before: { dateCreated?: any; dateCompleted?: any },
        after: { dateCreated?: any; dateCompleted?: any }
    ): void {
        this.logDateFieldChangeIfDifferent(serviceRequestId, 'dateCreated', before.dateCreated, after.dateCreated);
        this.logDateFieldChangeIfDifferent(serviceRequestId, 'dateCompleted', before.dateCompleted, after.dateCompleted);
    }

    logServiceRequestStatusChanges(
        serviceRequestId: number,
        before: { requestStatusId?: any; recordStatus?: any; statusReasonId?: any },
        after: { requestStatusId?: any; recordStatus?: any; statusReasonId?: any }
    ): void {
        this.logScalarFieldChangeIfDifferent(serviceRequestId, 'requestStatusId', before.requestStatusId, after.requestStatusId);
        this.logScalarFieldChangeIfDifferent(serviceRequestId, 'recordStatus', before.recordStatus, after.recordStatus);
        this.logScalarFieldChangeIfDifferent(serviceRequestId, 'statusReasonId', before.statusReasonId, after.statusReasonId);
    }

    private logDateFieldChangeIfDifferent(
        serviceRequestId: number,
        columnName: string,
        oldVal: any,
        newVal: any
    ): void {
        const oldNorm = this.normalizeTxDate(oldVal);
        const newNorm = this.normalizeTxDate(newVal);
        this.postFieldChangeIfDifferent(serviceRequestId, columnName, oldNorm, newNorm);
    }

    private logScalarFieldChangeIfDifferent(
        serviceRequestId: number,
        columnName: string,
        oldVal: any,
        newVal: any
    ): void {
        let oldNorm = oldVal === undefined || oldVal === null ? '' : String(oldVal);
        let newNorm = newVal === undefined || newVal === null ? '' : String(newVal);
        if (oldNorm !== '' && newNorm !== '' && !isNaN(Number(oldNorm)) && !isNaN(Number(newNorm))
            && Number(oldNorm) === Number(newNorm)) {
            return;
        }
        this.postFieldChangeIfDifferent(serviceRequestId, columnName, oldNorm, newNorm);
    }

    private postFieldChangeIfDifferent(
        serviceRequestId: number,
        columnName: string,
        oldNorm: string,
        newNorm: string
    ): void {
        if (oldNorm === newNorm) {
            return;
        }
        const txHist: TransactionHistory = new TransactionHistory();
        txHist.setRecord('Edit', 'ServiceRequests', serviceRequestId, '');
        txHist.valueChange(oldNorm, newNorm, columnName);
        this.postTxHistoryRecord(txHist).subscribe(
            () => {},
            (error) => {
                alert(error);
            }
        );
    }

    private normalizeTxDate(val: any): string {
        if (val === undefined || val === null || val === '') {
            return '';
        }
        const d = new Date(val);
        if (isNaN(d.getTime())) {
            return String(val);
        }
        return DwUtils.formatReadableDate(d);
    }

    getAllTransactionHistoryByForeignKey(fkTable: string, fKey: string, entityVal: string, timeFrame: string, suppKeyVal:string): Observable<any> {
        return this.http.get<any>(this.URLPath + fkTable + '/' + fKey + '/' + entityVal + '/' + timeFrame + '/' + suppKeyVal)
            .pipe(
                retry(1)
            );
    }

    postTxHistoryRecord(record: TransactionHistory): Observable<any> {
        return this.http.post(this.URLPath, record)
            .pipe(
                retry(1)
            );
    }

}
